import "./hb-navbar.module.css";
import { html } from "lit-html";
import Strings from "../../../models/Strings.json";

export default (user, lang) => html`
    <nav
        class="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
        <div
            class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
            <aside class="flex items-center space-x-3 rtl:space-x-reverse">
                <a
                    href="#/menu"
                    class="inline-flex items-center p-2 w-10 h-8 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    aria-controls="hb-menu"
                    data-drawer-show="hb-menu"
                    aria-expanded="false">
                    <span class="sr-only">Open main menu</span>
                    <svg
                        class="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 17 14">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 1h15M1 7h15M1 13h15" />
                    </svg>
                </a>
                <a
                    href="#"
                    class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white"
                    >Vault<sub class="text-xs ms-1 text-gray-400">alpha</sub></a
                >
            </aside>
            <div
                class="flex md:order-2 space-x-0 md:space-x-0 rtl:space-x-reverse">
                <button
                    id="hb-navbar-start"
                    data-drawer-show="hb-onboard"
                    class="${user
                        ? "hidden"
                        : "inline-flex"} items-center text-white bg-logo dark:bg-logo/40 cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    <svg
                        class="hidden flex-shrink-0 mr-2 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                    </svg>
                    Get Started
                </button>
                <a
                    id="hb-navbar-onboard"
                    data-drawer-show="hb-onboard"
                    class="${user
                        ? "inline-flex"
                        : "hidden"} text-white items-center bg-logo dark:bg-logo/40 cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    <svg
                        class="hidden flex-shrink-0 mr-2 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                    </svg>
                    Begin Here
                </a>
                <button
                    data-dropdown-toggle="hb-navbar-language"
                    class="ml-3 inline-flex items-center px-2 text-xl font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none dark:text-white focus:ring-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    type="button">
                    <span>${Strings.flag[lang]}</span>
                    <svg
                        class="hidden w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 4 15">
                        <path
                            d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                    </svg>
                </button>
                <!-- Dropdown menu -->
                <div
                    id="hb-navbar-language"
                    class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 dark:bg-gray-700 dark:divide-gray-600">
                    <ul
                        class="py-2 text-sm text-gray-700 dark:text-gray-200"
                        aria-labelledby="hb-navbar-language">
                        <li
                            id="hb-navbar-language-en"
                            class="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                            <span class="mr-1 text-lg">${Strings.flag.en}</span>
                            ${Strings.english[lang]}
                        </li>
                        <li
                            id="hb-navbar-language-km"
                            class="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                            <span class="mr-1 text-lg">${Strings.flag.km}</span>
                            ${Strings.khmer[lang]}
                        </li>
                        <li
                            id="hb-navbar-language-fi"
                            class="opacity-50 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                            <span class="mr-1 text-lg">${Strings.flag.fi}</span>
                            ${Strings.finnish[lang]}
                        </li>
                    </ul>
                    <div class="hidden py-2">
                        <a
                            href="#"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                            >Separated Link</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </nav>
`;
